var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"auth-modal",attrs:{"name":"modal-card","width":"500px","height":"360px","adaptive":true,"clickToClose":false}},[_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }